module.exports = __webpack_public_path__ + "img/bg3.1624c0b6.png";